<template>
  <svg width="0" height="0" class="svg-defs" aria-hidden="true">
    <defs>
      <symbol id="star" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01L12 2z" />
      </symbol>
      <linearGradient id="ksg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#F17C08" />
        <stop offset="1" stop-color="#C63E7C" />
      </linearGradient>
      <symbol id="ks-quote" viewBox="0 0 88 64">
        <path d="M30 8 C14 16 8 30 10 46 C11 54 18 58 25 56 C33 54 36 44 31 38 C27 33 20 33 17 36 C16 24 22 14 34 9" fill="none" stroke="url(#ksg)" stroke-width="9" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M72 8 C56 16 50 30 52 46 C53 54 60 58 67 56 C75 54 78 44 73 38 C69 33 62 33 59 36 C58 24 64 14 76 9" fill="none" stroke="url(#ksg)" stroke-width="9" stroke-linecap="round" stroke-linejoin="round" />
      </symbol>
      <symbol id="viluu-heart" viewBox="0 0 24 24">
        <path d="M12 7C9.5 4 5 4 3 8C1 12 5 15.5 12 20C19 15.5 23 12 21 8C19 4 14.5 4 12 7Z" />
      </symbol>
      <!-- Viluu-Schloss: weiche Radien wie die Karten, runde Kappen wie die
           Welle. Ohne stroke-Attribut — Farbe kommt vom <use>-Aufruf. -->
      <symbol id="ico-lock" viewBox="0 0 24 24">
        <rect x="3.4" y="10.2" width="17.2" height="10.8" rx="3.8" fill="none" stroke-width="2.2" />
        <path d="M7.9 10.2V7.4a4.1 4.1 0 0 1 8.2 0v2.8" fill="none" stroke-width="2.2" stroke-linecap="round" />
      </symbol>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'KennenlernenSvgDefs',
};
</script>
